import { areFieldsPristine, areAnyFieldsPristine, validateLengthAndContent } from "../FieldValidators";
const OPTIONAL_ADDRESS_FIELDS = ["address2", "primaryContactNumber"];

/**
 * Validates the user inputs of address form
 *
 * @param {object} fields
 * @param {boolean} isMandatory
 */
export const validateAddressForm = (fields, isMandatory) => {
  let fieldErrors = {};
  const hasChanged = !areFieldsPristine(fields);
  if (!hasChanged) {
    return {
      fieldErrors,
      isFormInvalid: isMandatory
    };
  }
  if (!fields.primaryContactNumber.phoneIsValid) {
    fieldErrors.primaryContactNumber = "Please enter correct phone number";
  }
  fieldErrors = {
    ...fieldErrors,
    ...validateLengthAndContent(fields.address1, {
      label: "Address Line 1",
      dataKey: "address1",
      maxLength: 256,
      checkEmpty: isMandatory
    })
  };
  fieldErrors = {
    ...fieldErrors,
    ...validateLengthAndContent(fields.address2, {
      label: "Address Line 2",
      dataKey: "address2",
      maxLength: 256,
      checkEmpty: false,
      minLength: 0
    })
  };
  fieldErrors = {
    ...fieldErrors,
    ...validateLengthAndContent(fields.town, {
      label: "Town/City",
      dataKey: "town",
      maxLength: 256,
      regexType: "specialChars",
      checkEmpty: isMandatory
    })
  };
  fieldErrors = {
    ...fieldErrors,
    ...validateLengthAndContent(fields.postalCode, {
      label: "Postal/Zip Code",
      dataKey: "postalCode",
      regexType: "specialChars",
      checkEmpty: isMandatory
    })
  };
  let mandatoryFieldsComplete = true;
  if (isMandatory) {
    const mandatoryFields = {};
    //remove address 2 as it's always optional
    Object.keys(fields).map(key => {
      if (!OPTIONAL_ADDRESS_FIELDS.includes(key)) {
        mandatoryFields[key] = fields[key];
        mandatoryFieldsComplete = !areAnyFieldsPristine(mandatoryFields);
      } else {
        mandatoryFieldsComplete = false;
      }
    });
  }
  const isFormInvalid = Object.keys(fieldErrors).length > 0 || mandatoryFieldsComplete;
  return {
    fieldErrors,
    isFormInvalid
  };
};